import { startOfDayInTz } from '@etiquetachef/types';

/**
 * Millis epoch do início do dia ISO `YYYY-MM-DD` no fuso do TENANT — o
 * `newDueAt` que o `PostponeDueDateDialog` manda ao `postponeRenewalAdmin`.
 *
 * Origem: sem issue — commit f1f9556aa, 2026-06-11 19:41 +0200 (era o
 * `isoDateToMillis` dentro do diálogo); movido para cá na #935 (item 6),
 * 2026-10-13 10:40 +0200, para ser testável sem o `DatePicker`.
 *
 * Arquitetura: o vencimento é do tenant, então a meia-noite é a do fuso dele
 * (`startOfDayInTz`, `packages/types/src/wallTime.ts`), nunca a do navegador.
 *
 * Falhas conhecidas:
 *  - Até 2026-10-13 (#935, item 6): usava `new Date('<iso>T00:00:00')`, a
 *    meia-noite do NAVEGADOR — um admin na Itália prorrogando um tenant BR
 *    gravava a meia-noite de Roma (4–5 h antes da de São Paulo).
 *
 * Contrato: `''` ou data inválida → `null`.
 *
 * Usado por: `PostponeDueDateDialog.tsx` (`handleSubmit`) e
 * `isPostponeDateEnabled`, abaixo. Teste: `postponeDueDate.test.ts`.
 */
export function postponeDayStartMs(iso: string, timeZone: string): number | null {
  if (!iso) return null;
  // Bug corrigido em 2026-10-13 10:40 +0200 (#935, item 6): era a meia-noite
  // do fuso do navegador. `startOfDayInTz` devolve `null` para data inválida.
  return startOfDayInTz(iso, timeZone);
}

/**
 * O dia de calendário que o `DatePicker` entrega pode ser escolhido? Mesmo
 * piso do servidor (`newDueAt > agora` e `> current_period_end`), medido na
 * meia-noite do tenant que vai ser enviada.
 *
 * Origem: #935 (item 6) — 2026-10-13 10:40 +0200. Antes comparava a meia-noite
 * do navegador com o vencimento.
 *
 * Contrato: `date` é o `Date` local que o Cloudscape passa (só ano/mês/dia
 * importam). `currentDue` em epoch ms ou `null` (sem assinatura).
 *
 * Usado por: `isDateEnabled` do `PostponeDueDateDialog`.
 */
export function isPostponeDateEnabled(
  date: Date,
  timeZone: string,
  currentDue: number | null,
  nowMs: number,
): boolean {
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const startMs = postponeDayStartMs(`${String(date.getFullYear())}-${mm}-${dd}`, timeZone);
  return startMs !== null && startMs > Math.max(nowMs, currentDue ?? 0);
}
